export default {
  // API_ENDPOINT: 'http://localhost:8000/api',
  API_ENDPOINT: `https://safe-taiga-14978.herokuapp.com/api`,
  // API_KEY: process.env.REACT_APP_API_KEY,
  TOKEN_KEY: 'aware-client-auth-token',
}